import { render, staticRenderFns } from "./ConsultaInventario.vue?vue&type=template&id=6cd27b1b"
import script from "./ConsultaInventario.vue?vue&type=script&lang=js"
export * from "./ConsultaInventario.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports